import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { EnumHelper, LoanInfoDto, ProductName, TransactionType } from "common";
import { AccountData } from "../../account/account.model";
import { AccountTransactionSimulationResolver } from "./transaction-simulation.resolver";
import { AccountService } from "../../account/account.service";
import { SimulationTransactionData } from "../transaction.model";

@Injectable({ providedIn: "root" })
export abstract class AccountTransactionSimulationPaymentResolver
  extends AccountTransactionSimulationResolver {

  protected constructor(
    accountService: AccountService,
    router: Router
  ) {
    super(accountService, router);
  }

  protected override createSimulationTransactionData(accountData: AccountData, loanInfo: LoanInfoDto, accountId: number): SimulationTransactionData {
    const accountTransferData = {
      loan: {
        id: loanInfo.id,
        description: accountData.description,
        paymentAmount: loanInfo.paymentAmount
      },
      balanceAfter: {
        availableBalance: loanInfo?.availableFunds,
        outstandingBalance: loanInfo?.principalBalance,
        upcomingPaymentAmount: loanInfo?.upcomingPayment,
        upcomingPaymentDate: loanInfo?.paymentDueDate ? new Date(loanInfo?.paymentDueDate) : null
      },
      from: loanInfo?.disbursementBankName && loanInfo?.disbursementBankAccount
        ? `${loanInfo?.disbursementBankName} ${loanInfo?.disbursementBankAccount}`
        : 'Your bank account on file',
      to: `${EnumHelper.getNameFromValue(ProductName, accountData.productCode)}: ${accountData.loanNumber}`,
      type: TransactionType.Payment,
    };

    return {
      accountTransferData,
      accountId: accountId,
      amountInput: '',
      amountMinimum: loanInfo?.minPaymentAmount,
      amountMaximum: loanInfo?.currentPayoffAmount,
      weeklyPaymentAmount: loanInfo?.paymentAmount,
      paymentFrequency: accountData.offer?.paymentFrequency,
      productCode: accountData.productCode,
    };
  }
}